// extracted by mini-css-extract-plugin
export default {"termsAndConditionsContainer":"LbDZC","actions":"fhDrY","termsAndConditions":"Zj_0n"};